import styled from 'styled-components';
import { compose, flex, layout, space } from 'styled-system';

// Components
import Box from '../Box';

/**
 * Style the div for Row;
 * include margin from theme.gutters
 * (cannot be overridden)
 */
export const StyledWrapperContainer = styled(Box)`
  ${({ theme }) => {
    let style = 'width: 100%;';
    const themeBkpts = Object.keys(theme.breakpoints);
    // order theme breakpoints by size
    const sortedThemeBkpts = themeBkpts.sort((keyA, keyB) => {
      return (
        parseInt(theme.breakpoints[keyA], 10) -
        parseInt(theme.breakpoints[keyB], 10)
      );
    });
    // create media query (at 0px) to apply same maxwidths from smallest theme
    // breakpoint; this media query must be applied first
    if (sortedThemeBkpts.length) {
      style += `
        @media screen and (min-width: 0px) {
          max-width: ${theme.maxWidths[0]};
          padding-right: ${theme.margins[0]};
          padding-left:  ${theme.margins[0]};
        }
      `;
    }
    // for all theme breakpoints, create media query (at that breakpoint)
    // to apply maxWidths
    sortedThemeBkpts.forEach(key => {
      if (theme.gutters[key] !== undefined) {
        style += `
          @media screen and (min-width: ${theme.breakpoints[key]}) {
            max-width: ${theme.maxWidths[key]};
            padding-right: ${theme.margins[key]};
            padding-left:  ${theme.margins[key]};
          }
        `;
      }
    });
    return style;
  }}
  .no-gutters & {
    max-width: 100%;
    ${space}
  }
  margin-right: auto;
  margin-left:  auto;
  ${compose(flex, layout)}
`;